import { createContext, useContext } from 'react';

import type { Market } from './types';

export interface MarketContextValue {
  market: Market;
  setMarket: (market: Market) => void;
}

export const MarketContext = createContext<MarketContextValue | null>(null);

export function useMarket(): MarketContextValue {
  const ctx = useContext(MarketContext);
  if (ctx === null) {
    throw new Error('useMarket 必須在 <MarketProvider> 之內使用。');
  }
  return ctx;
}
